import { Navigate } from "react-router-dom";
import Error from "../page/error";
import UnAuthorize from "../page/unAuthorize";
import LogIn from "../page/user/login";
import Registration from "../page/user/Registration";
import AppLayout from "../component/layout/AppLayout";
import Dashboard from "../page/app/dashboard";
import { appRoot } from "./constant/CONSTANTS";
import ForgetPassword from "../page/user/Registration/forgetPass";
import Users from "../page/app/users";
import UserDetail from "../page/app/users/user-detail";
import DeviceType from "../page/app/device";
import DeviceDetails from "../page/app/device/device-details";
import Pets from "../page/app/pet";
import Feedback from "../page/app/feedback";
import Config from "../page/app/config";
import PetDetails from "../page/app/pet/pet-details";
import Notification from "../page/app/notification";
import BenchMark from "../page/app/benchmark";
import BenchMarkActivity from "../page/app/benchmark/activity";
import Plan from "../page/app/plans";
import SubPlans from "../page/app/plans/subPlan";

export const ROUTES = {
  FORGOT_PASSWORD: "/forgot-password",
  DASHBOARD: "/analytics",
  USERS: "/users",
  USERS_DETAIL: "/users/:id",
  DEVICE: '/device',
  DEVICE_DETAIL: '/device/:id',
  PETS: '/pets',
  PETS_DETAIL: '/pets/:id',
  FEEDBACK: '/feedback',
  CONFIG: '/config',
  NOTIFICATION: '/notification',
  BECHMARK: '/benchmark',
  BECHMARK_ACTIVIY: '/benchmark/activity/:id',
  PLAN: '/plan',
  SUB_PLAN: '/plan/sub-plan/:id',


};

const LOGIN_ROUTES = [
  // {
  //   path: "/",
  //   element: <SidePage />,
  //   errorElement: <Error />,
  //   children: [
  //     {
  //       index: true,
  //       element: <LogIn />,
  //     },
  //     {
  //       path: "registration",
  //       element: <Registration />,
  //     },
  //   ],
  // },
  {
    index: true,
    element: <LogIn />,
  },
  {
    path: "registration",
    element: <Registration />,
  },
  {
    path: ROUTES.FORGOT_PASSWORD,
    element: <ForgetPassword />,
    errorElement: <Error />,
  },
];

const ALL_ROUTES = (appProps) => [
  ...LOGIN_ROUTES,

  {
    path: `${appRoot}`,
    element: <AppLayout {...appProps} />,
    children: [
      {
        index: true,
        element: <Navigate to={`${appRoot}${ROUTES.DASHBOARD}`} />,
      },
      {
        path: `${appRoot}${ROUTES.DASHBOARD}`,
        element: <Dashboard {...appProps} />,
      },
      {
        path: `${appRoot}${ROUTES.USERS}`,
        element: <Users {...appProps} />,
      },

      {
        path: `${appRoot}${ROUTES.USERS_DETAIL}`,
        element: <UserDetail {...appProps} />,
      },
      {
        path: `${appRoot}${ROUTES.DEVICE}`,
        element: <DeviceType {...appProps} />,
      },
      {
        path: `${appRoot}${ROUTES.DEVICE_DETAIL}`,
        element: <DeviceDetails {...appProps} />,
      },
      {
        path: `${appRoot}${ROUTES.PETS}`,
        element: <Pets {...appProps} />,
      },
      {
        path: `${appRoot}${ROUTES.BECHMARK}`,
        element: <BenchMark {...appProps} />,
      },
      {
        path: `${appRoot}${ROUTES.BECHMARK_ACTIVIY}`,
        element: <BenchMarkActivity {...appProps} />,
      },
      {
        path: `${appRoot}${ROUTES.PETS_DETAIL}`,
        element: <PetDetails {...appProps} />,
      },
      {
        path: `${appRoot}${ROUTES.FEEDBACK}`,
        element: <Feedback {...appProps} />,
      },
      {
        path: `${appRoot}${ROUTES.CONFIG}`,
        element: <Config {...appProps} />,
      },
      {
        path: `${appRoot}${ROUTES.NOTIFICATION}`,
        element: <Notification {...appProps} />,
      },
      {
        path: `${appRoot}${ROUTES.PLAN}`,
        element: <Plan {...appProps} />,
      },
      {
        path: `${appRoot}${ROUTES.SUB_PLAN}`,
        element: <SubPlans {...appProps} />,
      },

    ],
  },
  {
    path: "/error",
    element: <Error />,
  },
  {
    path: "/unAuthorize",
    element: <UnAuthorize />,
  },
  {
    path: "*",
    element: <Navigate to="/error" />,
  },
];

export default ALL_ROUTES;
